module.exports = __webpack_public_path__ + "img/switch.58212334.svg";